export default function BeforeAfter() {
    return (
        <section
            id="cambio"
            data-testid="beforeafter-section"
            className="bg-[#F4F1EA] py-28 md:py-40"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-12">
                <div className="max-w-[820px]">
                    <h2 className="font-serif-display text-4xl md:text-6xl tracking-tight text-[#1A1A1A] leading-[1.05]">
                        El día antes. El día después.
                    </h2>
                </div>

                <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20">
                    <div data-testid="before-block">
                        <p className="text-xs tracking-[0.28em] uppercase text-[#666666] mb-6">
                            El día antes
                        </p>
                        <p className="text-base md:text-lg text-[#1A1A1A] leading-[1.75] max-w-[520px]">
                            Tu equipo persigue, llama y reagenda. Pasa la mañana entre el CRM y
                            WhatsApp. Los leads buenos pasan por delante y se te enfrían porque
                            nadie los cogió a tiempo. Tú dedicas las pocas horas que te quedan
                            al trabajo que solo tú puedes hacer — pero llegas tarde a casi todo.
                        </p>
                    </div>

                    <div
                        data-testid="after-block"
                        className="md:border-l md:border-[#E5E0D5] md:pl-12"
                    >
                        <p className="text-xs tracking-[0.28em] uppercase text-[#8B6914] mb-6">
                            El día después
                        </p>
                        <p className="text-base md:text-lg text-[#1A1A1A] leading-[1.75] max-w-[520px]">
                            Los leads entran y son atendidos en menos de cinco minutos. Cualquier
                            hora. Cualquier día. Los buenos llegan a tu mesa ya cualificados, con
                            la cita agendada en tu calendario y la información que necesitas para
                            empezar a vender desde el primer segundo. Los menos buenos se quedan
                            en seguimiento automático, no en una hoja olvidada. Tú dedicas las
                            horas a lo único que paga: vender y cerrar.
                        </p>
                    </div>
                </div>

                <div className="mt-20 flex flex-col items-center">
                    <span className="block h-px w-12 bg-[#8B6914]" aria-hidden="true" />
                    <p className="mt-6 font-serif-display italic text-xl md:text-2xl text-[#1A1A1A] text-center">
                        No reemplazamos a tu equipo. Lo liberamos.
                    </p>
                </div>
            </div>
        </section>
    );
}
